import React from 'react'

const AssetManagers = () => {
  return (
    <>
      <div className="bg_img2">
          <div className="container">
            <h3>Asset Managers</h3>
            <div className="d-flex justify-content-center mt-4">
            </div>
          </div>
        </div>
    </>
  )
}

export default AssetManagers